var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgICloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8485 5L4.99999 19.8485L4.15146 19L19 4.15147L19.8485 5Z",
    fill: "#10141A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15145 5L19 19.8485L19.8485 19L4.99998 4.15147L4.15145 5Z",
    fill: "#10141A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICloseBtn);
export default __webpack_public_path__ + "static/media/i_close_btn.18775809e277dc70e2a5b1e1090f1b84.svg";
export { ForwardRef as ReactComponent };